import { PrescriptionTypes, PrescriptionsListItem } from '@lib/core/models/prescription.interface';

export interface Visit {
  id: string;
  type: VisitTypes;
  status: VisitStatusTypes;
  medicalData?: MedicalData;
  userFullName: string;
  metadata?: VisitMetaData;
  systemMetadata?: VisitSystemMetaData;
  userId: string;
  creationDate: string;
  parentActionId: string;
  baseActionId: string;
  expirationDate: string;
  paymentType: string;
  isPaid: boolean;
  contractNumber?: string;
  prescriptions?: PrescriptionsListItem[];
  price?: number;
  partnerId?: string;
  appointmentDate?: string;
}

export interface VisitMetaData {
  type?: PrescriptionTypes;
  name?: string;
  doctor_name?: string;
  doctor_specialties?: string;
  appointment_id?: string;
  appointment_date?: string;
  appointment_time?: string;
  appointment_date_with_year?: string;
  appointment_full_date?: string;
  location_id?: string;
  location?: string;
  partner_id?: string;
  partner_name?: string;
  duration_description?: string;
  provider?: string;
  doctor_id?: string;
  count?: string;
  order_id?: string;
  event_place?: AppointmentEventPlaceType;
  meeting_link?: string;
  forbidden?: string;
  order_number?: string;
}

export interface VisitSystemMetaData {
  guarantee_application_id?: string;
  appointment_id?: string;
  location_id?: string;
  external_appointment_id?: string;
}

export enum VisitStatusTypes {
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Created = 'Created',
  Archived = 'Archived',
  ToDo = 'ToDo',
  Done = 'Done',
  Expired = 'Expired',
  Rejected = 'Rejected',
  Exception = 'Exception',
}

export interface BindAppointmentRequestModel {
  location?: string;
  eventPlace?: AppointmentEventPlaceType;
  externalAppointmentId?: string;
  actionId?: string;
  appointmentId?: string;
  startDate?: Date;
  endDate?: Date;
  locationId?: string;
  doctorId?: string;
  comment?: string;
  franchise: number;
}

export enum AppointmentTypes {
  Appointment = 'Appointment',
  InstrumentalDiagnostic = 'InstrumentalDiagnostic',
  LaboratoryService = 'LaboratoryService',
  Drugs = 'Drugs',
}

export enum AppointmentProviderType {
  Unknown = 'Unknown',
  Helsi = 'Helsi',
  Eleks = 'Eleks',
  Dila = 'Dila',
}

export enum VisitTypes {
  PrescriptionToDo = 'PrescriptionToDo',
  AppointmentToDo = 'AppointmentToDo',
}

export interface AppointmentSearchModel {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  operators?: unknown;
  userId?: string;
  type?: VisitTypes;
  status?: VisitStatusTypes;
  parentActionId?: string;
  baseActionId?: string;
  creationDate?: string;
  expirationDate?: string;
  completedAt?: string;
  userFullName?: string;
  metadata?: VisitMetaData;
  systemMetadata?: VisitSystemMetaData;
  from?: Date;
  to?: Date;
}

export interface ExistingAppointmentSearchRequest {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  operators?: unknown;
  memberId?: string;
  memberName?: string;
  userId?: string;
  doctorId?: string;
  dateStart?: Date;
  dateEnd?: Date;
  provider?: string;
  status?: string;
  type?: string;
  serviceId?: string;
  serviceName?: string;
}

export interface Appointment {
  id: string;
  providerType: AppointmentProviderType;
  type: PrescriptionTypes;
  status: AppointmentStatus;
  userId: string;
  memberId: string;
  memberName: string;
  dateStart: string;
  dateEnd: string;
  actionId: string;
  externalAppointmentId: string;
  externalPatientId: string;
  serviceId: string;
  serviceName: string;
  doctorName: string;
  appointmentDate: string;
  appointmentTime: string;
  durationDescription: string;
  location: string;
  latitude: number;
  longitude: number;
  doctorId: string;
  isFirstVisit: boolean;
  eventPlace: AppointmentEventPlaceType;
  meetingLink: string;
  descriptions: string;
  extraData: ExtraData;
  price: number;
  partnerName: string;
  franchise?: number;
}

export enum AppointmentStatus {
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Created = 'Created',
}

interface ExtraData {
  google_event_id: string;
  meet_link: string;
  event_place: AppointmentEventPlaceType;
  helsi_timeslot_id: string;
  helsi_location_id: string;
}

export enum AppointmentEventPlaceType {
  Hospital = 'Hospital',
  Home = 'Home',
  Telemedicine = 'Telemedicine',
}

export interface MedicalData {
  fields?: {
    names?: string;
  };
  items: MedicalRecord[];
}

export interface MedicalRecord {
  id: string;
  type: string;
  hasStructuredData: boolean;
  documents: Document;
}

export interface Document {
  [id: string]: string;
}
